module.exports = __webpack_public_path__ + "static/media/mui.11cd5808.svg";